import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { environment } from "../../../../../src/environments/environment"
import { AuthservicesService } from 'src/app/services/authservices.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  form: FormGroup;
  error: string;
  id;
  loading = false;
  submitted = false
  errorMessage 
  constructor(
    private fb: FormBuilder, public router: Router, private authenticationService: AuthservicesService) { }


  ngOnInit(): void {
    this.errorMessage = environment.errorMessage

    this.form = this.fb.group({ 
      email: [null, [Validators.required, Validators.email]],
    });
  }
  get f() { return this.form.controls; }

   onSubmit(){
    this.submitted = true;
    if (this.form.invalid) {
        return;
    }
    if (this.form.valid) {
      console.log(this.form.value, '###')
      let email = this.form.get('email').value
      let obj = {email: email, role:"Community"}
      this.authenticationService.forgotPassword(obj).subscribe(
        (response:any) => {
          let data = response['data'];
          let obj = {requestToken: data.requestToken, email:email}
          console.log(obj, 'testing123')
          localStorage.setItem('requestToken', JSON.stringify(obj))
          this.router.navigate(["/change-password"]);
          this.authenticationService.successMessage(environment.otpMessage,'success')
        },
        error => {
          if (error) {
            this.authenticationService.successMessage(error.error.message,'error')
          }
        }
      );
    }
  }

}

